var _rect, _path, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourseFallBack = function SvgCourseFallBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 258,
    viewBox: "0 0 460 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 258,
    fill: "#F1F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 258L359 0V258H101Z",
    fill: "#DDEEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    width: 101,
    height: 258,
    fill: "#DDEEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3957_1458)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 300,
    height: 178,
    rx: 8,
    fill: "#515478"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3957_1458)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 48,
    width: 284,
    height: 162,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 284,
    height: 15,
    transform: "translate(88 48)",
    fill: "#0A182E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 54,
    width: 61,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 75,
    width: 158,
    height: 92,
    rx: 4,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 109,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#279AF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 127V115L185 121L176 127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 75.5,
    width: 93,
    height: 19,
    rx: 3.5,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 75.5,
    width: 93,
    height: 19,
    rx: 3.5,
    stroke: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 79,
    width: 18,
    height: 12,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 100,
    width: 92,
    height: 18,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 100,
    width: 92,
    height: 18,
    rx: 3,
    stroke: "#F1F8FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 103,
    width: 18,
    height: 12,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 124,
    width: 92,
    height: 18,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 124,
    width: 92,
    height: 18,
    rx: 3,
    stroke: "#F1F8FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 127,
    width: 18,
    height: 12,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 148,
    width: 92,
    height: 18,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 148,
    width: 92,
    height: 18,
    rx: 3,
    stroke: "#F1F8FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 151,
    width: 18,
    height: 12,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 172,
    width: 92,
    height: 18,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 172,
    width: 92,
    height: 18,
    rx: 3,
    stroke: "#F1F8FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 175,
    width: 18,
    height: 12,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 196,
    width: 92,
    height: 18,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 196,
    width: 92,
    height: 18,
    rx: 3,
    stroke: "#F1F8FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 199,
    width: 18,
    height: 12,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 177,
    width: 61,
    height: 4,
    rx: 2,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 187,
    width: 96,
    height: 2,
    rx: 1,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 191,
    width: 81,
    height: 2,
    rx: 1,
    fill: "#BFDAF4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3957_1458",
    x: 52,
    y: 16,
    width: 356,
    height: 234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3957_1458"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0941176 0 0 0 0 0.180392 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3957_1458"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3957_1458"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0941176 0 0 0 0 0.180392 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3957_1458",
    result: "effect2_dropShadow_3957_1458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3957_1458",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3957_1458"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 48,
    width: 284,
    height: 162,
    rx: 2,
    fill: "white"
  })))));
};
export default SvgCourseFallBack;